import deepmerge from "deepmerge";

import { MyLensesRoleType, type ResourceContainer, ResourceKind } from "../../../gql-generated/types";
import {
    LENS_FOLDER_ROLE_TYPE_PERMISSIONS,
    type LensFolderRoleType,
    type LensFolderRoleTypePermissions,
    ORGANIZATION_ROLE_TYPE_PERMISSIONS,
    type OrganizationRoleType,
} from "../../constants";

const getPermissionsFromRoles = (
    roles: readonly MyLensesRoleType[],
    kind: ResourceKind,
): LensFolderRoleTypePermissions => {
    const userContainerPermissions: LensFolderRoleTypePermissions[] = [];

    for (const roleType of roles) {
        if (kind === ResourceKind.Organizations) {
            userContainerPermissions.push(ORGANIZATION_ROLE_TYPE_PERMISSIONS[roleType as OrganizationRoleType]);
        } else if (kind === ResourceKind.LensSpaces) {
            userContainerPermissions.push(LENS_FOLDER_ROLE_TYPE_PERMISSIONS[roleType as LensFolderRoleType]);
        }
    }

    return userContainerPermissions.reduce(
        (allPermissions, permissions) => deepmerge(allPermissions, permissions),
        LENS_FOLDER_ROLE_TYPE_PERMISSIONS[MyLensesRoleType.RoleTypeUnset],
    );
};

export const getLensFolderPermissionsWithContainer = (
    lensFolderContainer: ResourceContainer | null,
    containersIndex: Map<string, ResourceContainer>,
): LensFolderRoleTypePermissions => {
    if (!lensFolderContainer) {
        return LENS_FOLDER_ROLE_TYPE_PERMISSIONS[MyLensesRoleType.RoleTypeUnset];
    }

    if (lensFolderContainer.roles.length > 0) {
        return getPermissionsFromRoles(lensFolderContainer.roles, lensFolderContainer.kind);
    }

    const orgContainer = containersIndex.get(lensFolderContainer.parentName);
    if (orgContainer && orgContainer.roles.length > 0) {
        return getPermissionsFromRoles(orgContainer.roles, orgContainer.kind);
    }

    return LENS_FOLDER_ROLE_TYPE_PERMISSIONS[MyLensesRoleType.RoleTypeUnset];
};
